const AT_STORAGE = "@aprincipal:accesstoken";
const RT_STORAGE = "@aprincipal:refreshtoken";
const UD_STORAGE = "@aprincipal:userdata";
const ST_STORAGE = "@aprincipal:availablestores";
const CM_STORAGE = "@aprincipal:cadastrometas";

export { AT_STORAGE, RT_STORAGE, UD_STORAGE, ST_STORAGE, CM_STORAGE };
